
import React, { useEffect, useState } from "react";
import { withGeneral } from "../../context/mixin/with-general";
import { UpdateRequestsContainer } from "./update-requests.style";
import GoBack from "../../components/go-back";
import InputBox from "../../components/input-box/input-box";
import Loader from "../../components/loader";
import MainButton from "../../components/main-button";
import SelectBox from "../../components/select-box/select-box";
import { HIRING_STATUS, SIGNIG_STATUS_SELECT_BOX, STATUS_TYPE_SELECT_BOX } from "../hirings/new-hiring/types";
import HiringServices from "../../services/HiringServices";
import InfoModal from "../../components/info-modal";
import { images } from "../../assets";
import LeftInfoModal from "../../components/left-info-modal";

const ActualizacionSolicitudes = (props: any) => {

  const [requestId, setRequestId] = useState('');
  const [requestNumber, setRequestNumber] = useState('');
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState<any>({});
  const [policyError, setPolicyError] = useState("");
  const [showSignStatus, setShowSignStatus] = useState(false);
  const [showHiringStatus, setShowHiringStatus] = useState(false);
  const [showNumPoliza, setShowNumPoliza] = useState(false);
  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const [signValue, setSignValue] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [showModalError, setShowModalError] = useState(false);


  useEffect(() => {
    if (requestId) {
      const delayDebounceFn = setTimeout(() => {
        setLoader(true)
        const fetchData = async () => {
          const data = await HiringServices.checkHiring(false, props.setLoading, requestId)
          setData(data)
        }
        fetchData().catch(() => {
          setLoader(false)

        })
        // Send Axios request here
      }, 1500)
      return () => clearTimeout(delayDebounceFn)
    }
  }, [requestId])

  useEffect(() => {
    setLoader(false)
    if (data.id) {
      setPolicyError('')
      setShowSignStatus(true)
      setShowHiringStatus(true)
      setSignValue(data.signatureStatus)
      setStatusValue(data.status)
      setRequestNumber(data.policyNumber)
    } else {
      setPolicyError('no-data')
      setShowSignStatus(false)
      setShowHiringStatus(false)
    }
  }, [data])

  useEffect(() => {
    if (statusValue && statusValue === "EMITIDA") {
      setShowNumPoliza(true)
    } else {
      setShowNumPoliza(false)
    }
  }, [statusValue])
  const _checkIfUpdate = () => {
    //Comprobamos el estado de firma, el estado de la solicitud
    if (signValue && statusValue && (data.signatureStatus !== signValue || data.status !== statusValue || data.policyNumber !== requestNumber)) {
      return true
    }
    return false
  }
  const updateHiring = async () => {
    const data: any = {
      policyId: requestId,
      estadoFirma: signValue,
      estadoSolicitud: statusValue,
    }
    if (requestNumber) {
      data.numPoliza = Number(requestNumber)
    }
    try {
      const req = await HiringServices.updateHiringRequest(false, props.setLoading, data)
      setShowModalSuccess(true)
    } catch (ex) {
      setShowModalError(true)
    }
  }
  return (

    <UpdateRequestsContainer>
      <div className="go-back-head">
        <GoBack />
      </div>
      {loader && <Loader />}
      <LeftInfoModal
        img={images.IconWarningYellow}
        mainTitle={"Se va a actualizar la contratación"}
        mainText={"Asegurate que no se pierde integridad."}
        buttonText="Aceptar"
        closeButtonText="Cancelar"
        close={() => setShowModalConfirm(false)}
        active={showModalConfirm}
        onClickAccept={() => updateHiring()}
        className="warning"
      />
      <LeftInfoModal
        img={images.ArrowSelectDownBlue}
        mainTitle={"Se ha actualizazo correctamente la solicitud"}
        buttonText="Aceptar"
        noSecondaryButton
        close={() => setShowModalSuccess(false)}
        active={showModalSuccess}
        onClickAccept={() => setShowModalSuccess(false)}
      />
      <LeftInfoModal
        img={images.WarningError}
        mainTitle={"Se ha producido un error al actualizar"}
        buttonText="Aceptar"
        noSecondaryButton
        close={() => setShowModalError(false)}
        active={showModalError}
        onClickAccept={() => setShowModalError(false)}
        className="error"
      />
      <div className="data-flow-status">
        <div className="data-flow-status-title">
          <h2>ACTUALIZACIÓN MANUAL DE SOLICITUD</h2>
        </div>
      </div>
      <div className="atention">
        <h4>ATENCIÓN: esta vista actualiza manualmente la solicitud en base de datos de forma persistente</h4>
      </div>
      <div className="container-column">
        <div className="updateRequests-column">
          <div className="updateRequests-row first-row">
            <div className="inputBox">
              <InputBox
                errorCode={policyError}
                required={true}
                onChange={(value: string) => setRequestId(value)}
                placeholder="Solicitud"
                type={"number"}
                value={requestId}
              />
            </div>
          </div>
          {(showSignStatus) &&
            <div className="updateRequests-row first-row">
              <div className="selectBox">
                <SelectBox
                  optionsText={SIGNIG_STATUS_SELECT_BOX.sort((a, b) => a.label.localeCompare(b.label))}
                  optionKey="value"
                  optionValue="label"
                  onChange={(value: string) => setSignValue(value)}
                  className="required"
                  initialValue={signValue}
                  defaultValue={signValue}
                />
                <label>Estado firma</label>
              </div>
            </div>
          }
          {showHiringStatus &&
            <div className="updateRequests-row first-row">
              <div className="selectBox">
                <SelectBox
                  optionsText={STATUS_TYPE_SELECT_BOX.sort((a, b) => a.label.localeCompare(b.label))}
                  optionKey="value"
                  optionValue="label"
                  onChange={(value: string) => setStatusValue(value)}
                  className="required"
                  initialValue={statusValue}
                  defaultValue={statusValue}
                />
                <label>Estado solicitud</label>
              </div>
            </div>
          }
          {showNumPoliza &&
            <div className="updateRequests-row first-row">
              <div className="inputBox">
                <InputBox
                  required={true}
                  onChange={(value: string) => setRequestNumber(value)}
                  placeholder="Nº poliza"
                  type={"number"}
                  value={requestNumber}

                />
              </div>
            </div>
          }
          {_checkIfUpdate() &&
            <div className="updateRequests-row first-row">
              <div className="inputBox">
                <MainButton icon={true} disabled={false} text={"Actualizar"} onClick={() => setShowModalConfirm(true)} />
              </div>
            </div>
          }

        </div>
      </div>
    </UpdateRequestsContainer>
  )
}


export default withGeneral(ActualizacionSolicitudes);
